import { Stack } from "@mui/material";
import Icon from "components/templatesComponents/Icon";
import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React from "react";

const HelpBlock = (props) => {
  const { icon, iconTitle, title, link, linkLabel } = props;

  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: "center",
        maxWidth: { xs: 236, md: 253 },
        "& > p": { fontSize: "1.125rem", lineHeight: "1.75rem", fontWeight: 700, textAlign: "center" },
      }}
    >
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <img src={`/${icon}.svg`} alt="" />
        <h3 className="fr-text--md fr-text--regular">{iconTitle}</h3>
      </Stack>
      <p>{title}</p>
      <Link {...link}>
        {linkLabel}
        <Icon iconDSFR="arrow-right-line" size="sm" sx={{ pl: 1 }} />
      </Link>
    </Stack>
  );
};

HelpBlock.propTypes = {
  icon: PropTypes.string.isRequired,
  iconTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.shape().isRequired,
  linkLabel: PropTypes.string.isRequired,
};

export default HelpBlock;
